export interface Testimonial {
  id: number;
  name: string;
  rating: number;
  text: string;
  service: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Marie K.',
    rating: 4.8,
    text: 'Une expérience divine ! Le massage relaxant aux huiles m\'a complètement détendue. L\'ambiance est apaisante, les senteurs sont divines et l\'équipe est aux petits soins. Je recommande à 100% !',
    service: 'Massage Relaxant',
    date: 'Juin 2026',
  },
  {
    id: 2,
    name: 'Aïcha B.',
    rating: 4.6,
    text: 'Mon visage n\'a jamais été aussi éclatant. Le soin hydratant est magique ! Les produits sentent divinement bon et Djeneba a su m\'expliquer chaque étape avec patience.',
    service: 'Soin du Visage',
    date: 'Mai 2026',
  },
  {
    id: 3,
    name: 'Fatou D.',
    rating: 4.9,
    text: 'J\'ai fait mes locks chez KD\'S et le résultat est magnifique. L\'équipe est patiente, professionnelle et à l\'écoute. Enfin un salon où je me sens belle et respectée !',
    service: 'Coiffure',
    date: 'Juillet 2026',
  },
  {
    id: 4,
    name: 'Esther L.',
    rating: 4.5,
    text: 'La manucure spa est un vrai moment de plaisir. Le bain aromatique, le massage des mains... c\'est le détail qui change tout. Mes ongles sont impeccables depuis 3 semaines.',
    service: 'Manucure & Pédicure',
    date: 'Juin 2026',
  },
  {
    id: 5,
    name: 'Yasmine N.',
    rating: 4.3,
    text: 'J\'ai testé le rehaussement de cils et je suis conquise ! Mon regard est sublimé au naturel. Plus besoin de mascara le matin. Merci pour cette expertise incroyable.',
    service: 'Beauté du Regard',
    date: 'Avril 2026',
  },
  {
    id: 6,
    name: 'Sophie T.',
    rating: 4.7,
    text: 'Le soin du corps gommage est à tomber ! Ma peau est incroyablement douce. L\'enveloppement aux huiles est un pur moment de détente. Je reviens très vite pour le forfait prestige.',
    service: 'Soin du Corps',
    date: 'Juillet 2026',
  },
];